module.exports = "img/7.b79ebc.webp";